const HW_CODE = Symbol('HW_CODE') //              货位

// 正则
const regs = {}
regs[HW_CODE] = /^HW.+?(?=(\.|$))/

/**
 * 解析 货位 类
 *
 * @class AnalysisHwCode
 * @param {string} [code=""] 待解析字符串
 *
 */
export default class AnalysisHwCode {
  constructor(code = '') {
    if (!this.m) this.m = new Map()

    // 待解析的货位
    this.code = this.preprocess(code)
    //
    this.analysis()
  }

  // 预处理待解析 code
  preprocess(code) {
    console.log('待预处理 code: ', code)
    const _code = `${code}`.toUpperCase() // 转换为大写
    if (!new RegExp('^HW', 'i').test(_code)) throw new Error('请输入正确的货位条码！')
    console.log('预处理后 code: ', _code)
    return _code
  }

  // 解析
  analysis() {
    this.analysisHwCode()
  }

  /* 解析 */
  // 解析货位
  analysisHwCode() {
    const ret = this.code.match(regs[HW_CODE])
    this.m.set(HW_CODE, ret ? ret[0] : '')
  }

  // 返回 Map
  map() {
    return {
      hw: { label: '货位', value: this.m.get(HW_CODE) || null },
    }
  }
}
